<footer>
    <div class="footer-top">
        <picture>
            <source media="(max-width: 768px)" srcset="../../../assets/logos/logos_movil.svg">
            <img class="footer-logos" src="../../../assets/logos/logos_horizontal.svg" alt="Logos europeos">
        </picture>
    </div>

    <div class="separator"></div>

    <div class="footer-content">
        <div class="footer-column">
            <h3>{{'FOOTER.EXPLORE' | translate}}</h3>
            <ul>
                <li><a [routerLink]="paths.HOME" routerLinkActive="footer-link-active"
                        [routerLinkActiveOptions]="{exact: true}">{{'FOOTER.HOME' | translate}}</a></li>
                <li><a [routerLink]="paths.MAP" routerLinkActive="footer-link-active">{{'FOOTER.MAP' | translate}}</a></li>
                <li><a [routerLink]="paths.WONDERS" routerLinkActive="footer-link-active">{{'FOOTER.WONDERS' | translate}}</a></li>
                <li><a [routerLink]="paths.SURVEY" routerLinkActive="footer-link-active">{{'FOOTER.SURVEY' | translate}}</a></li>
            </ul>
        </div>

        <div class="footer-column">
            <h3>{{'FOOTER.LEGAL' | translate}}</h3>
            <ul>
                <li><a [routerLink]="paths.LEGAL" routerLinkActive="footer-link-active">{{'FOOTER.LEGAL_NOTICE' | translate}}</a></li>
                <li><a [routerLink]="paths.PRIVACY" routerLinkActive="footer-link-active">{{'FOOTER.PRIVACY' | translate}}</a>
                </li>
                <li><a [routerLink]="paths.COOKIES" routerLinkActive="footer-link-active">{{'FOOTER.COOKIES' | translate}}</a></li>
                <li><a [routerLink]="paths.GOOD_PRACTICES" routerLinkActive="footer-link-active">{{'FOOTER.GOOD_PRACTICES' | translate}}</a></li>
            </ul>
        </div>
    </div>

</footer>
